export interface WhizChatConfiguration {
    tenant: string;
    clientId: string;
    socketUrl: string;
    restUrl: string;
    jwtSecret: string;
    authorizerOptions: AuthorizerOptions;
}

export interface AuthorizerOptions {
    authMechanism: AuthMechanism;
    authorizerName?: string;
    initialToken?: string;
}

export enum AuthMechanism {
    HMAC = "hmac",
    TOKEN = "token"
}

export enum AuthEnvironment {
    DEV = "dev",
    STAGING = "staging",
    PROD = "prod"
}